export default function SummaryCard({ title, value, icon }) {
    return (
        <div className="bg-white p-4 rounded-2xl shadow flex items-center justify-between">
            <div>
                <div className="text-sm text-gray-500">{title}</div>
                <div className="text-xl font-bold">{value}</div>
            </div>
            <div className="text-2xl">{icon}</div>
        </div>
    );
}